import React from 'react';
import { LoaderContextual } from './loader-contextual';
import { LoaderGlobal } from './loader-global';

interface LoaderComposition {
  Global: typeof LoaderGlobal;
  Contextual: typeof LoaderContextual;
}

export const LoadingIndicator: React.FC & LoaderComposition = () => null;

LoadingIndicator.Global = LoaderGlobal;
LoadingIndicator.Contextual = LoaderContextual;
